export default __webpack_public_path__ + "static/media/book_trial_animation.0e540d82.mp4";